import React from 'react';
import ShowToast from '@ingka/toast';
import { Toast } from '../contexts/Toast';
import { noop } from '../types/common';

interface ShowToastItemProps {
  toast?: Toast;
  onClose: () => void;
}
export const ShowToastItem: React.FC<ShowToastItemProps> = ({
  toast,
  onClose,
}): JSX.Element | null => {
  const { text = '', buttonText = '', action = noop } = toast || {};

  return !!text ? (
    <div
      role="status"
      aria-live="polite"
    >
      <ShowToast
        text={text}
        actionButtonText={buttonText}
        actionClick={action}
        onCloseRequest={onClose}
        isOpen={!!text}
      />
    </div>
  ) : null;
};
